import { useEffect, useRef } from "react";

export default function FloatingButton() {
  const btnRef = useRef<HTMLAnchorElement>(null);

  useEffect(() => {
    const btn = btnRef.current;
    if (!btn) return;
    let lastScroll = window.scrollY;
    const onScroll = () => {
      const current = window.scrollY;
      if (current > lastScroll && current > 200) {
        btn.style.transform = "translateY(0)";
      } else if (current < 100) {
        btn.style.transform = "translateY(120%)";
      }
      lastScroll = current;
    };
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <a
      ref={btnRef}
      href="tel:0374471036"
      className="fixed bottom-5 left-4 right-4 z-50 md:hidden bg-[#FF6B4A] text-white py-4 rounded-xl font-semibold text-lg flex items-center justify-center gap-2 shadow-xl shadow-[#FF6B4A]/30 hover:bg-[#FF6B4A]/90 transition-all duration-300 translate-y-0"
    >
      <span className="relative flex h-3 w-3 mr-1">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75" />
        <span className="relative inline-flex rounded-full h-3 w-3 bg-white" />
      </span>
      Appeler 03 74 47 10 36
    </a>
  );
}